const WHATSAPP_URL = 'https://wa.me/5511986765185?text=Ol%C3%A1!%20Quero%20garantir%20meu%20or%C3%A7amento%20travado%20para%20fechamento%20de%20sacada.';

const condicoes = [
  {
    icon: 'ri-hand-coin-line',
    valor: '10%',
    label: 'de Sinal',
    desc: 'Apenas 10% para reservar sua instalação e travar o preço.',
  },
  {
    icon: 'ri-tools-line',
    valor: '90%',
    label: 'Após Instalação',
    desc: 'O restante somente depois da conclusão e sua aprovação.',
  },
  {
    icon: 'ri-bank-card-line',
    valor: '10x',
    label: 'Sem Juros',
    desc: 'Parcele em até 10 vezes no cartão sem acréscimos.',
  },
];

export default function OfertaCta() {
  return (
    <>
      {/* Oferta */}
      <section className="py-16 md:py-20 bg-stone-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-[0.03]">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20smooth%20glass%20texture%20subtle%20light%20reflection%20minimal%20dark%20elegant%20background%20pattern%20clean%20modern%20aesthetic&width=1920&height=800&seq=lp-bg-glass-02&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-6 text-center">
          <span className="inline-block bg-amber-500 text-white text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest mb-5">
            OFERTA LIMITADA
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 max-w-2xl mx-auto leading-tight">
            Reserve com 10% de sinal e trave o orçamento por 10 meses
          </h2>
          <p className="text-white/55 text-xs md:text-sm mb-10 max-w-md mx-auto">
            Seu preço não muda, mesmo que a instalação aconteça meses depois. Proteção total contra reajustes.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
            {condicoes.map((c) => (
              <div key={c.label} className="bg-white/5 border border-amber-500/25 rounded-2xl p-6">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-amber-500/15 text-amber-400 mx-auto mb-3">
                  <i className={`${c.icon} text-xl`}></i>
                </div>
                <p className="text-3xl font-bold text-amber-400 mb-1">{c.valor}</p>
                <p className="text-white font-semibold text-xs mb-2">{c.label}</p>
                <p className="text-white/50 text-xs leading-relaxed">{c.desc}</p>
              </div>
            ))}
          </div>

          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold px-10 py-4 rounded-full text-base md:text-lg transition-all duration-200 whitespace-nowrap hover:scale-105 cursor-pointer shadow-lg shadow-green-500/30"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl"></i>
            </div>
            GARANTIR MEU ORÇAMENTO AGORA
          </a>
          <p className="text-white/35 text-xs mt-4">Vagas limitadas por região. Consulte disponibilidade.</p>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-3">
            Pronto para transformar sua sacada?
          </h2>
          <p className="text-stone-500 text-sm mb-8 max-w-md mx-auto">
            Fale agora com um consultor técnico. Atendimento personalizado, sem compromisso.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white font-bold px-10 py-4 rounded-full text-base md:text-lg transition-all duration-200 whitespace-nowrap hover:scale-105 cursor-pointer shadow-lg shadow-green-500/30"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-whatsapp-line text-xl"></i>
            </div>
            FALAR COM CONSULTOR AGORA
          </a>
          <p className="text-stone-400 text-xs mt-4">
            Resposta rápida · Atendemos toda São Paulo e Grande SP
          </p>
        </div>
      </section>
    </>
  );
}